import { render } from "./product-evaluation-copy.vue?vue&type=template&id=d212b80e"
import script from "./product-evaluation-copy.vue?vue&type=script&lang=js"
export * from "./product-evaluation-copy.vue?vue&type=script&lang=js"

import "./product-evaluation-copy.vue?vue&type=style&index=0&id=d212b80e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__